import { render, staticRenderFns } from "./workCard.vue?vue&type=template&id=394f8ba2"
import script from "./workCard.vue?vue&type=script&lang=js"
export * from "./workCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports